import { FC } from 'react';
import { Container, Box, Flex, Heading, Text } from '@chakra-ui/react';

import './About.scss';

const About: FC = () => {
    return (
        <div className="About" data-testid="About">
            <Flex
                minH="50vh"
                alignItems="center"
                justifyContent="center"
                bg="gray.50"

            >
                <Container maxW="1200px" w="100%">
                    <Box
                        p={{ base: 4, md: 8 }}
                        borderRadius="md"
                        w="100%"
                        textAlign="center"

                    >
                        <Flex
                            direction={{ base: 'column', md: 'row' }}
                            justifyContent="space-between"
                            alignItems="center"
                            gap={10}
                        >
                            <Box flex="1" textAlign={{ base: 'center', md: 'left' }}>
                                <Text
                                    whiteSpace="pre-line"
                                    fontSize={{ base: '2xl', md: '4xl' }}
                                    fontWeight="bold"
                                    lineHeight="shorter"
                                    color="color.600"
                                    textTransform="uppercase"
                                >
                                    Criatividade e tradição{'\n'}em cada detalhe artesanal
                                </Text>
                            </Box>

                            <Box flex="1" textAlign={{ base: 'center', md: 'start' }}>
                                <Heading
                                    as="h2"
                                    size="xl"
                                    mb={4}
                                    textTransform="uppercase"
                                    color="color.500"
                                >
                                    Donna Cegonha
                                </Heading>
                                <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.900">
                                    A Donna Cegonha nasceu em 2010 do carinho e da dedicação de Daniella Carvalho,
                                    artesã e empreendedora, que sempre acreditou que cada detalhe feito à mão carrega
                                    sentimentos únicos. O que começou como um amor pelo artesanato transformou-se em uma
                                    marca que acompanha famílias em momentos especiais, pode ser com a chegada de um bebê,
                                    com fraldinhas bordadas, macacões infantis personalizados ou até mesmo os artesanatos
                                    exclusivos de imagens católicas, como Santas e Santos com personalização exclusiva.
                                    Na Donna Cegonha toda jornada é feito à mão!
                                </Text>
                            </Box>
                        </Flex>
                    </Box>
                </Container>
            </Flex>
        </div>
    );
};

export default About;
